"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHeaderValues = createHeaderValues;
const shared_1 = require("../../shared");
const header_1 = require("../../shared/header");
const createBloodGroup_1 = require("./createBloodGroup");
const createBmi_1 = require("./createBmi");
const createCombinedTransplant_1 = require("./createCombinedTransplant");
const createHeight_1 = require("./createHeight");
const createHyperImmunised_1 = require("./createHyperImmunised");
const createLongStatus_1 = require("./createLongStatus");
const createPatientEtId_1 = require("./createPatientEtId");
const createWaitingListTime_1 = require("./createWaitingListTime");
const createWeight_1 = require("./createWeight");
const messages_1 = require("./messages");
function createHeaderValues(intl, options) {
    const { formatMessage } = intl;
    return [
        {
            label: formatMessage(messages_1.messages.name),
            value: (0, shared_1.createPatientName)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.maidenNameOfMother),
            value: (0, header_1.createMaidenNameOfMother)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.status),
            value: (0, createLongStatus_1.createLongStatus)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.waitingList),
            value: (0, createWaitingListTime_1.createWaitingListTime)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.patientEtId),
            value: (0, createPatientEtId_1.createPatientEtId)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.ssn),
            value: (0, header_1.createSocialSecurityNumber)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.address),
            value: (0, header_1.createAddress)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.phoneNumber),
            value: (0, header_1.createPhoneNumber)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.bloodGroup),
            value: (0, createBloodGroup_1.createBloodGroup)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.dateOfBirth),
            value: (0, header_1.createDateOfBirth)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.age),
            value: (0, header_1.createAge)(intl, options)
        },
        {
            label: formatMessage(messages_1.messages.weight),
            value: (0, createWeight_1.createWeight)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.height),
            value: (0, createHeight_1.createHeight)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.bmi),
            value: (0, createBmi_1.createBmi)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.combinedTransplant),
            value: (0, createCombinedTransplant_1.createCombinedTransplant)(intl, options).value
        },
        {
            label: formatMessage(messages_1.messages.hyperImmunised),
            value: (0, createHyperImmunised_1.createHyperImmunised)(intl, options).value
        }
    ];
}
